<template>
	<v-container>
		<v-row align="center" justify="center" v-if="loading != 'loading'">
			<v-col cols="12" sm="8" md="6" lg="4">
				<v-card class="elevation-12">
					<v-toolbar dark color="primary">
						<v-toolbar-title>Выбор пароля</v-toolbar-title>
					</v-toolbar>
					<v-card-text>
						<v-form v-model="valid" ref="form">
							<v-text-field
								v-model="username"
								disabled
								prepend-icon="person"
								name="login"
								label="Электронная почта"
							></v-text-field>
							<v-text-field
								v-model="password"
								prepend-icon="lock"
								label="Пароль"
								type="password"
								:rules="[
									v => v.length >= 8 || 'Минимум 8 символов'
								]"
								v-on:keyup.enter="setPassword"
							></v-text-field>
							<v-text-field
								v-model="passwordCheck"
								prepend-icon="lock"
								label="Проверка пароля"
								type="password"
								:rules="[
									v => v == password || 'Пароли не совпадают'
								]"
								v-on:keyup.enter="setPassword"
							></v-text-field>
						</v-form>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							@click.prevent="setPassword"
							:disabled="!valid"
						>
							Готово
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
		<v-row align="center" justify="center" v-if="loading == 'loading'">
			<v-col cols="12" sm="8" md="6" lg="4">
				<v-progress-linear :indeterminate="true" color="secondary"></v-progress-linear>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import {api} from '../../lib/api'
	import _ from 'lodash'

	export default {
		data: () => ({
			username: '',
			password: '',
			passwordCheck: '',
			loading: false,
			valid: true,
		}),
		computed: {
		},
		created() {
			this.loading = true

			api.post('users/check_password_recovery_link', {
				link: this.$route.params.link
			})
			.then(response => {
				this.loading = false
				if (response.data.check) {
					this.username = response.data.username
				}
				else {
					this.$router.push('/')
				}
			}, error => {})
		},
		methods: {
			setPassword() {
				if (this.$refs.form.validate()) {
					this.loading = true
					api.post('users/set_password', {
						link: this.$route.params.link,
						password: this.password
					})
					.then(response => {
						this.loading = false
						this.$store.dispatch('retrieveToken', {
							username: this.username,
							password: this.password
						})
						this.$store.dispatch('dialogNotify', {
							title: 'Пароль установлен',
							message: 'Пароль успешно установлен'
						})
					}, error => {})
				}
			}
		}
	}
</script>
